const observer = new IntersectionObserver(
  ([event]) =>
    event.target.classList.toggle('is-stuck', event.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(document.querySelector('.js-masthead'));
